import { IWorkflowRequest } from "src/app/models/workflow-request.model";
import { ReduxWrapper } from "../../app.state";

export const myWorkflowsRequestInitialState: ReduxWrapper<IWorkflowRequest[]> = {
	error: undefined,
	loadedOnce: false,
	loading: false,
	value: []
};
